import React from 'react';
import { ColorPicker } from 'antd';

const ColorSelector = ({ value, onChange, previousColors }) => {
  return (
    <div className="flex items-center space-x-2">
      <ColorPicker
        value={value}
        onChange={(color) => onChange(color.toHexString())}
      />
      <div className="flex space-x-1">
        {previousColors.map((color, index) => (
          <div
            key={index}
            className={`w-6 h-6 rounded-full cursor-pointer ${
              value === color ? 'ring-2 ring-offset-2 ring-blue-500' : ''
            }`}
            style={{ backgroundColor: color }}
            onClick={() => onChange(color)}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorSelector;

